import Vue from 'vue'
import _ from 'lodash'
import store from '..'
import { findNoteHelper } from '../../js/noteTemplates/noteHelpers'

function customItemToTreeItem (items, itemId, getters) {
  let item = items[itemId]
  if (!item) return null

  let noteHelper = findNoteHelper(itemId)
  let ti = noteHelper.getFormattedTreeItem()

  // Set defaults if missing
  ti.id = itemId
  if (!('children' in ti)) {
    let children = []
    if ('children' in item) {
      item.children.forEach(i => {
        let ti = customItemToTreeItem(items, i, getters)
        if (ti !== null) {
          children.push(ti)
        }
      })
    }
    ti.children = children
  }

  return ti
}

export const updateItems = (state, items) => {
  state.items = items
}

export const updateSelectedTreeItemId = (state, selectedTreeItem) => {
  state.selectedTreeItemId = selectedTreeItem
}

// These three mutations are mostly for updating the state from firestore
export const addItem = (state, newItem) => {
  Vue.set(state.items, newItem.id, newItem)
}

export const setItem = (state, item) => {
  Vue.set(state.items, item.id, item)
}

export const removeItem = (state, idToRemove) => {
  Vue.delete(state.items, idToRemove)
}

export const modifyItem = (state, itemToModify) => {
  // let processedItem = processOnLoad(itemToModify) // Can't do here, needs to be synchronous!!!
  if (_.isMatch(state.items[itemToModify.id], _.omit(itemToModify, ['updatedAt']))) {
    console.log('Contents identical so not modified: ' + itemToModify.id)
    return
  }
  Vue.set(state.items, itemToModify.id, itemToModify)
}

export const setNavTreeRootId = (state, navTreeRootId) => {
  state.navTreeRootId = navTreeRootId
}

export const setNavTree = (state, navTree) => {
  state.navTree = navTree
}

export const buildNavTree = (state, rootId) => {
  let r = []
  if (store.state.auth.currentUser == null) {
    state.navTree = []
    return
  }

  if (Object.keys(state.items).length === 0 && state.items.constructor === Object) {
    state.navTree = []
    return
  }

  if (rootId == null) {
    store.state.auth.currentUser.rootItems.forEach(ri => {
      let ti = customItemToTreeItem(state.items, ri, store.getters)
      if (ti !== null) {
        r.push(ti)
      } // TODO if not, remove it from the children array!?
    })
  } else {
    let ti = customItemToTreeItem(state.items, rootId, store.getters)
    if (ti !== null) {
      r.push(ti)
    }
  }
  state.navTree = r
}
